import { UserLoggedInNavigatorScreenProps } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModalStack } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModalStack";
import React from "react";
import { TeamWhitelistUsers } from "../TeamAdmin/TeamWhitelistUsers";

function TeamCreateWhitelistUserC(
  props: UserLoggedInNavigatorScreenProps<"TeamCreateWhitelistUser">
) {
  return (
    <TeamWhitelistUsers
      goBack={() => props.navigation.goBack()}
      teamId={props.route.params.teamId}
      setOptions={props.navigation.setOptions}
    />
  );
}

export const TeamCreateWhitelistUser = withWebModalStack(
  TeamCreateWhitelistUserC
);
